// hooks/useProdottiBySottoProdotto.js
import { useState, useEffect } from 'react';
import axios from 'axios';

export const useProdottiBySottoProdotto = (sottoProdottoId) => {
    const [prodotti, setProdotti] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [count, setCount] = useState(0);

    useEffect(() => {
        const fetchProdottiCompleti = async () => {
            if (!sottoProdottoId) {
                setProdotti([]);
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                setError(null);
                
                // ✅ Aggiunto /api/
                const response = await axios.get(`/api/prodotti/sottogruppi/${sottoProdottoId}/completi`);
                
                // ✅ Corretto: response.status invece di response.ok
                if (response.status !== 200) {
                    throw new Error(`Errore HTTP: ${response.status}`);
                }
                
                // ✅ Corretto: response.data invece di response.json()
                const result = response.data;
                
                if (result.success) {
                    const prodottiAttivi = result.data.filter(
                        prodotto => prodotto.attivo !== false
                    );
                    
                    setProdotti(prodottiAttivi);
                    setCount(result.count || prodottiAttivi.length);
                } else {
                    setProdotti([]);
                    setCount(0);
                    setError(result.message || 'Errore nel recupero prodotti');
                }
                
            } catch (err) {
                setError(err.message);
                setProdotti([]);
                setCount(0);
            } finally {
                setLoading(false);
            }
        };
        
        fetchProdottiCompleti();
    }, [sottoProdottoId]);
    
    return { 
        prodotti, 
        loading, 
        error,
        count
    };
};

// hooks/useProdottoCompleto.js
export const useProdottoCompleto = (prodottoId) => {
    const [prodotto, setProdotto] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProdottoCompleto = async () => {
            if (!prodottoId || isNaN(prodottoId)) {
                setProdotto(null);
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                setError(null);
                
                // ✅ Aggiunto /api/
                const response = await axios.get(`/api/prodotti/${prodottoId}/completo`);
                
                // ✅ Corretto: response.status invece di response.ok
                if (response.status !== 200) {
                    throw new Error(`Errore HTTP: ${response.status}`);
                }
                
                // ✅ Corretto: response.data invece di response.json()
                const result = response.data;
                
                if (result.success) {
                    if (Array.isArray(result.data) && result.data.length > 0) {
                        setProdotto(result.data[0]);
                    } else if (typeof result.data === 'object' && result.data !== null) {
                        setProdotto(result.data);
                    } else {
                        setProdotto(null);
                    }
                } else {
                    setProdotto(null);
                    setError(result.message || 'Prodotto non trovato');
                }
                
            } catch (err) {
                setError(err.message);
                setProdotto(null);
            } finally {
                setLoading(false);
            }
        };
        
        fetchProdottoCompleto();
    }, [prodottoId]);
    
    return { 
        prodotto, 
        loading, 
        error
    };
};